function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import PropTypes from "prop-types";
import "./style.css";

var Timeline = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Timeline, _Component);

  function Timeline() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Timeline.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "tg-timeline"
    }, this.props.children.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "tg-timeline-line"
    }), this.props.children);
  };

  return Timeline;
}(Component);

Timeline.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.arrayOf(PropTypes.element)
} : {};
export { default as TimelineEvent } from "./TimelineEvent";
export default Timeline;